import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/constants/services";

const CATEGORIES = [
  "Tümü",
  "Lazer",
  "Yüz Bakımı",
  "Cilt Bakımı",
  "Vücut Şekillendirme",
  "Güzellik",
  "Analiz",
];

export default function Services() {
  const [active, setActive] = useState("Tümü");

  const filtered =
    active === "Tümü"
      ? SERVICES
      : SERVICES.filter((s) => s.category === active);

  return (
    <section id="hizmetler" data-testid="services-section" className="iona-section bg-white">
      <div className="iona-container">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
              — Hizmetlerimiz
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight">
              Size özel, profesyonel{" "}
              <span className="italic text-[#5E2A84]">güzellik çözümleri</span>
            </h2>
          </div>
          <p className="text-[#4A4A4A] max-w-md">
            17 uzmanlık hizmeti ile cilt bakımından vücut şekillendirmeye, lazer
            epilasyondan güzellik uygulamalarına tüm ihtiyaçlarınız tek
            adreste.
          </p>
        </div>

        {/* Category filter */}
        <div className="flex flex-wrap gap-2.5 mb-12">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`service-filter-${c}`}
              onClick={() => setActive(c)}
              className={`px-5 py-2.5 rounded-full text-sm transition-all border ${
                active === c
                  ? "bg-[#5E2A84] text-white border-[#5E2A84]"
                  : "bg-white text-[#4A4A4A] border-[#E5E5E5] hover:border-[#5E2A84] hover:text-[#5E2A84]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {filtered.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <Link
                key={s.slug}
                to={`/hizmetler/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group relative rounded-2xl overflow-hidden bg-[#F8F9FA] iona-hover-lift border border-[#F0F0F0] flex flex-col"
                style={{ animationDelay: `${i * 50}ms` }}
              >
                <div className="relative overflow-hidden h-44">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent" />
                  <div className="absolute top-3 left-3 w-10 h-10 rounded-full bg-white/95 backdrop-blur flex items-center justify-center text-[#5E2A84]">
                    <Icon className="w-4 h-4" strokeWidth={1.5} />
                  </div>
                  <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/95 backdrop-blur flex items-center justify-center text-[#5E2A84] opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </div>
                  <div className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-white/95 backdrop-blur text-[10px] uppercase tracking-wider text-[#5E2A84]">
                    {s.category}
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-serif text-lg text-[#1A1A1A] mb-2 group-hover:text-[#5E2A84] transition-colors leading-snug">
                    {s.title}
                  </h3>
                  <p className="text-xs text-[#4A4A4A] leading-relaxed line-clamp-3 mb-4">
                    {s.short}
                  </p>
                  <div className="mt-auto inline-flex items-center gap-2 text-[#5E2A84] text-xs font-medium group-hover:gap-3 transition-all">
                    Detayları İncele
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
